module.exports = __webpack_public_path__ + "static/media/product_item.a09d1a8f.png";